export class YearlyFte {
	public year;
	public fte;

	constructor(obj) {
		this.year = obj.year;
		this.fte = obj.fte;
	}
} 
